import { useState } from 'react';
import axios from 'axios';

export default function UnbanModal({ decision, onClose, onDone }) {
  const [whitelist, setWhitelist] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const ip = decision.value;

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/decisions/unban', { ip, whitelist });
      onDone();
    } catch (e) {
      setError(e.response?.data?.detail || 'Erreur serveur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay onClose={onClose}>
      <h2 style={{ fontWeight:800, fontSize:'1.3rem', marginBottom:'0.3rem' }}>Débloquer une IP</h2>
      <p style={{ fontFamily:'var(--font-mono)', color:'var(--accent2)', fontSize:'1rem', marginBottom:'1.5rem' }}>{ip}</p>

      <div style={{ background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:'1rem', marginBottom:'1.5rem', fontSize:'0.85rem', color:'var(--muted)' }}>
        <div><strong style={{ color:'var(--text)' }}>Scénario :</strong> {decision.scenario || '—'}</div>
        <div><strong style={{ color:'var(--text)' }}>Pays :</strong> {decision.origin || '—'}</div>
        <div><strong style={{ color:'var(--text)' }}>Événements :</strong> {decision.events_count ?? 1}</div>
      </div>

      {/* Option whitelist */}
      <label style={{ display:'flex', alignItems:'flex-start', gap:'0.75rem', cursor:'pointer', marginBottom:'1.5rem', padding:'1rem', background:'var(--bg3)', border:`1px solid ${whitelist ? 'var(--green)' : 'var(--border)'}`, borderRadius:'var(--radius)', transition:'border-color 0.15s' }}>
        <input
          type="checkbox"
          checked={whitelist}
          onChange={e => setWhitelist(e.target.checked)}
          style={{ marginTop:'2px', accentColor:'var(--green)', width:16, height:16, flexShrink:0 }}
        />
        <div>
          <div style={{ fontWeight:700, color: whitelist ? 'var(--green)' : 'var(--text)' }}>Whitelister cette IP</div>
          <div style={{ color:'var(--muted)', fontSize:'0.8rem', marginTop:'0.2rem' }}>
            L'IP ne sera plus jamais bannie automatiquement par CrowdSec
          </div>
        </div>
      </label>

      {error && <div style={{ color:'var(--accent)', fontFamily:'var(--font-mono)', fontSize:'0.8rem', marginBottom:'1rem' }}>{error}</div>}

      <div style={{ display:'flex', gap:'0.75rem', justifyContent:'flex-end' }}>
        <button onClick={onClose} style={btnSecondary}>Annuler</button>
        <button onClick={handleSubmit} disabled={loading} style={{ ...btnPrimary, background: whitelist ? 'var(--green)' : 'var(--accent)' }}>
          {loading ? '…' : whitelist ? '✓ Débloquer et whitelister' : '✓ Débloquer'}
        </button>
      </div>
    </Overlay>
  );
}

const btnPrimary = {
  color:'#fff', border:'none', borderRadius:'var(--radius)',
  padding:'0.65rem 1.3rem', fontFamily:'var(--font-ui)',
  fontWeight:700, fontSize:'0.85rem', cursor:'pointer',
};
const btnSecondary = {
  background:'transparent', color:'var(--muted)',
  border:'1px solid var(--border)', borderRadius:'var(--radius)',
  padding:'0.65rem 1.3rem', fontFamily:'var(--font-ui)',
  fontWeight:600, fontSize:'0.85rem', cursor:'pointer',
};

function Overlay({ children, onClose }) {
  return (
    <div onClick={onClose} style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,0.7)',
      display:'flex', alignItems:'center', justifyContent:'center', zIndex:100,
      backdropFilter:'blur(4px)',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background:'var(--bg2)', border:'1px solid var(--border)',
        borderRadius:'12px', padding:'2rem', width:'100%', maxWidth:'460px',
        margin:'1rem', boxShadow:'0 20px 60px rgba(0,0,0,0.5)',
      }}>
        {children}
      </div>
    </div>
  );
}
